module.exports = __webpack_public_path__ + "img/vip-crown-line.1c4bc48f.svg";